import Joi from 'joi';

/**
 * Schema for released outbox record validation.
 */
export const releaseOutboxSchema = () =>
	Joi.object({})
		// Ignore extra fields
		.unknown();
